/**
 * 業種 API エンドポイント定義
 *
 * GET /api/industries      → useGetIndustriesQuery()
 * GET /api/industry-types  → useGetIndustryTypesQuery()
 */

import { api } from '../../store/api';

// ---------- 型定義 ----------

/** 業種（大分類） */
export interface IndustryItem {
  id: number;
  code: string;
  name: string;
  name_eng: string;
  display_order: number;
}

/** 業種区分 */
export interface IndustryTypeItem {
  id: number;
  industry_id: number;
  code: string;
  name: string;
  name_eng: string;
  display_order: number;
}

interface IndustryListResponse {
  industries: IndustryItem[];
}

interface IndustryTypeListResponse {
  industry_types: IndustryTypeItem[];
}

// ---------- エンドポイント ----------

const industryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getIndustries: builder.query<IndustryListResponse, void>({
      query: () => '/industries',
    }),
    getIndustryTypes: builder.query<IndustryTypeListResponse, void>({
      query: () => '/industry-types',
    }),
  }),
});

export const { useGetIndustriesQuery, useGetIndustryTypesQuery } = industryApi;
